import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/images/Mishti_Holidays_transparent.png';

const navLinks = [
  { label: 'Places', to: '/places' },
  { label: 'Packages', to: '/packages' },
  { label: 'Hotels', to: '/hotels' },
  { label: 'Food', to: '/food' },
  { label: 'Vehicles', to: '/vehicles' },
  { label: 'About', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  const transparent = isHome && !scrolled;

  return (
    <nav className={`navbar ${transparent ? 'navbar--transparent' : 'navbar--solid'}`}>
      <div className="navbar__inner">
        <Link to="/" className="navbar__logo">
        <img src={logo} alt="Mishti Holidays" className="navbar__logo-img" />
          {/* <div className="navbar__logo-main">Mishti <span>Holidays</span></div>
          <div className="navbar__logo-sub">× Onaara Tours</div> */}
        </Link>

        <ul className="navbar__links">
          {navLinks.map(l => (
            <li key={l.to}>
              <Link to={l.to} className={`navbar__link ${location.pathname === l.to ? 'navbar__link--active' : ''}`}>
                {l.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar__actions">
          {/* <Link to="/admin" className="navbar__cms-btn">⚙ CMS</Link> */}
          <Link to="/contact" className="navbar__cta btn-primary">Book Now</Link>
        </div>

        <button className="navbar__burger" onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      </div>

      <div className={`navbar__mobile ${menuOpen ? 'navbar__mobile--open' : ''}`}>
        {navLinks.map(l => (
          <Link key={l.to} to={l.to} className="navbar__mobile-link">{l.label}</Link>
        ))}
        <Link to="/admin" className="navbar__mobile-link">⚙ Admin CMS</Link>
        <Link to="/contact" className="navbar__mobile-cta">Book Now →</Link>
      </div>
    </nav>
  );
}
